<script lang="ts">
import { defineComponent, VNode } from 'vue';
import { debounce, DebouncedFunc } from 'lodash-es';

export type DebouncedUpdateCancel = () => void;

export default defineComponent({
  name: 'DebouncedUpdate',
  emits: { update: null },

  props: {
    debounceTime: {
      type: Number,
      required: false,
      default: 1000,
    },
  },

  data(): {
    debounced: DebouncedFunc<(event: any) => void>;
  } {
    return {
      debounced: null,
    };
  },

  render(): VNode {
    return this.$slots.default({
      debounced: this.debounced,
      cancel: this.cancel,
      instant: this.instant,
    })[0];
  },

  methods: {
    cancel() {
      this.debounced.cancel();
    },
    instant(event: any) {
      this.cancel();
      this.emit(event);
    },
    emit(event: any) {
      this.$emit('update', event);
    },
  },

  created() {
    this.debounced = debounce(this.emit, this.debounceTime);
  },

  beforeUnmount() {
    // Make sure the fn is called in case the element is destroyed
    this.debounced.flush();
  },
});
</script>
